import React, { useEffect, useState } from "react";
import Button from "../../components/Button";
import { useForm } from "react-hook-form";
import { handleBlur, handleShowPass } from "../../utility/action";
import {
  ForgotPasswordStep1Validation,
  ForgotPasswordStep2Validation,
} from "../../utility/Validation/validation";
import { yupResolver } from "@hookform/resolvers/yup";
import { notify } from "../../utility/Toastify/toastify";
import PoolData from "./AWSConfig/PoolData";
import { Link, useNavigate } from "react-router-dom";
import { CognitoUser } from "amazon-cognito-identity-js";
import "../../styles/pages/Auth/auth.css";
import { checkEmailException } from "../../utility/helper";
import axios from "axios";
import AuthAlert from "./AuthAlert";
import ConfirmAlert from "./ConfirmAlert";
import alert from "../../components/alerts/Alert";
import { MdEmail } from "react-icons/md";
import AuthLayout from "../../components/layout/AuthLayout";

function SignUpPage() {
  const [loading, setLoading] = useState(false);
  let navigate = useNavigate();
  const [stage, setStage] = useState(1);
  const [showAlert, setShowAlert] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [errorCode, setErrorCode] = useState("");
  const [showConfirmAlert, setShowConfirmAlert] = useState(false);
  const [userEmail, setUserEmail] = useState("");

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(
      stage === 1
        ? ForgotPasswordStep1Validation
        : ForgotPasswordStep2Validation,
    ),
  });

  const onsubmit = (data) => {
    setLoading(true);
    axios
      .post(
        "https://vtq2y0v4ed.execute-api.ap-southeast-2.amazonaws.com/dev/api",
        { mode: "check_status", email: checkEmailException(data?.email) },
      )
      .then((res) => {
        if (res.status === 201) {
          const getUser = () => {
            return new CognitoUser({
              Username: checkEmailException(data?.email),
              Pool: PoolData,
            });
          };

          if (data?.confirmationCode) {
            getUser().confirmPassword(data?.confirmationCode, data?.pass, {
              onSuccess: (data) => {
                notify(
                  "Your password has been successfully changed",
                  "success",
                );
                navigate("/auth/login");
                setLoading(false);
              },
              onFailure: (err) => {
                notify(err?.message, "error");
                setLoading(false);
              },
            });
          } else {
            getUser().forgotPassword({
              onSuccess: (data) => {
                notify("Verification code sent", "success");
                setLoading(false);
              },
              onFailure: (err) => {
                notify(err?.message, "error");
                setLoading(false);
              },
              inputVerificationCode: (data) => {
                // console.log("code sent", data);
                // notify(data, "success");
                setStage(2);
                setLoading(false);
                // return alert(
                //   "",
                //   "We've just sent a verification code to your email. If you don't see it in your inbox, please make sure to check your spam folder too.",
                //   "success",
                //   {
                //     cancel: "Close",
                //   },
                // );
              },
            });
          }
          return;
        }

        if (res.status === 203) {
          setLoading(false);
          setUserEmail(checkEmailException(data?.email));
          setErrorMsg(res.data.message);
          setShowConfirmAlert(true);
          return;
        }
        setLoading(false);
        setShowAlert(true);
        setErrorCode(res.status);
        setErrorMsg(res.data.message);
      })
      .catch((err) => {
        setLoading(false);
        setShowAlert(true);
        setErrorCode(err?.response?.status || 500);
        setErrorMsg(
          err?.response?.data?.message || "Network error. Please try again.",
        );
      });
  };

  useEffect(() => {
    if (stage === 2) {
      document.querySelector('input[name="confirmationCode"]').value = "";
    }
  }, [stage]);

  return (
    <>
      <AuthLayout>
        <div className="authContent">
          <h4 className="auth-title">Reset your password</h4>

          <form
            className="login100-form validate-form cc-auth__form"
            onSubmit={handleSubmit(onsubmit)}
            autoComplete="off"
          >
            {stage === 1 && (
              <>
                <p className="form-header">
                  Enter your email address to reset your password.
                </p>

                <div className="cc-auth__field">
                  <div
                    className={`wrap-input100 validate-input ${
                      errors.email && "border-error"
                    }`}
                  >
                    <input
                      className="input100 has-val"
                      type="text"
                      name="email"
                      placeholder="Email"
                      {...register("email")}
                      onBlur={(e) => handleBlur(e)}
                    />
                  </div>
                  {errors.email && (
                    <span className="error-text">{errors.email.message}</span>
                  )}
                </div>

                <Button
                  loading={loading}
                  ButtonText="Send Code"
                  className="signup cc-auth__primaryButton"
                />
              </>
            )}

            {stage === 2 && (
              <>
                <p className="form-header">Enter the verification code</p>

                <div className="cc-auth__field">
                  <div
                    className={`wrap-input100 validate-input ${
                      errors.confirmationCode && "border-error"
                    }`}
                  >
                    <input
                      className="input100 has-val"
                      type="text"
                      name="confirmationCode"
                      placeholder="Confirmation code"
                      autoComplete="off"
                      autoFocus
                      {...register("confirmationCode")}
                      onBlur={(e) => handleBlur(e)}
                    />
                  </div>
                  {errors.confirmationCode && (
                    <span className="error-text">
                      {errors.confirmationCode.message}
                    </span>
                  )}
                </div>

                <div className="cc-auth__field">
                  <div
                    className={`wrap-input100 validate-input ${
                      errors.pass && "border-error"
                    }`}
                  >
                    <span className="btn-show-pass">
                      <i
                        className="far fa-eye"
                        onClick={(e) => handleShowPass(e)}
                      ></i>
                    </span>
                    <input
                      className="input100 has-val"
                      type="password"
                      placeholder="Password"
                      {...register("pass")}
                      autoComplete="new-password"
                      onBlur={(e) => handleBlur(e)}
                    />
                  </div>
                  {errors.pass && (
                    <span className="error-text">{errors.pass.message}</span>
                  )}
                </div>

                <div className="cc-auth__field">
                  <div
                    className={`wrap-input100 validate-input ${
                      errors.confirmPass && "border-error"
                    }`}
                  >
                    <span className="btn-show-pass">
                      <i
                        className="far fa-eye"
                        onClick={(e) => handleShowPass(e)}
                      ></i>
                    </span>
                    <input
                      className="input100 has-val"
                      type="password"
                      placeholder="Confirm password"
                      {...register("confirmPass")}
                      autoComplete="off"
                      onBlur={(e) => handleBlur(e)}
                    />
                  </div>
                  {errors.confirmPass && (
                    <span className="error-text">
                      {errors.confirmPass.message}
                    </span>
                  )}
                </div>

                <Button
                  ButtonText="Reset"
                  className="signup cc-auth__primaryButton"
                  loading={loading}
                />

                <div className="spam-hint">
                  <MdEmail className="icon" />
                  Didn’t receive the code? Check your spam folder.
                </div>
              </>
            )}

            <div className="cc-auth__footer">
              <Link className="txt2" to="/auth/login">
                Go to Login
              </Link>
            </div>
          </form>
        </div>
      </AuthLayout>
      <AuthAlert
        show={showAlert}
        setShow={setShowAlert}
        code={errorCode}
        msg={errorMsg}
        mode={errorCode === 202}
      />
      <ConfirmAlert
        show={showConfirmAlert}
        setShow={setShowConfirmAlert}
        email={userEmail}
        msg={errorMsg}
        mode="changePass"
      />
    </>
  );
}

export default SignUpPage;
